import { useState, useEffect } from "react";

// ─── Constants ───────────────────────────────────────────────────────────────
const COUNTRIES = [
  { name: "Belgium", count: 1 }, { name: "China", count: 2 },
  { name: "France", count: 3 }, { name: "Germany", count: 3 },
  { name: "Ireland", count: 1 }, { name: "Italy", count: 3 },
  { name: "Netherlands", count: 2 }, { name: "Senegal", count: 1 },
  { name: "South Africa", count: 2 }, { name: "Spain", count: 2 },
  { name: "Swiss", count: 2 }, { name: "United Kingdom", count: 3 },
];

const ACTIONS_FULL = [
  { title: "ISO 50001",          date: "30/04/2021", status: "Đang làm", site: "DEMO20 · Shoppi..." },
  { title: "Thùng phân compost thứ 2", date: "30/04/2021", status: "Cần làm",       site: "DEMO20 · Shoppi..." },
  { title: "Rò rỉ nước",        date: "30/06/2021", status: "Đang làm", site: "DEMO20 · Shoppi..." },
  { title: "Bảo trì hàng năm...",  date: "31/07/2021", status: "Cần làm",       site: "DEMO20 · Shoppi..." },
  { title: "Hẹn giờ chiếu sáng...",   date: "27/07/2022", status: "Đang làm", site: "DEMO16 · Siège s..." },
  { title: "Kiểm toán nhiệt",    date: "05/08/2022", status: "Cần làm",       site: "DEMO16 · Siège s..." },
  { title: "Kiểm toán năng lượng",       date: "",           status: "Cần làm",       site: "DEMO20 · Shoppi..." },
];

const TOP_SITES  = ["DEMO16-S","DEMO20-S","DEMO1-Co","DEMO18-St","DEMO7-R","DEMO25-","DEMO11-A","DEMO15-V","DEMO21-S"];
const FLOP_SITES = ["DEMO14-C","DEMO6-H","DEMO8-Ma","DEMO24-","DEMO9-C","DEMO7-B","DEMO22-","DEMO12-","DEMO13-","DEMO25-"];
const TOP_VALUES  = [9.1,8.6,8.0,7.5,7.1,6.8,6.4,5.9,5.5];
const FLOP_VALUES = [2.1,2.4,2.7,3.0,3.3,3.6,3.9,4.2,4.5,4.8];

const CO2_SITES = ["DEMO20","DEMO7","DEMO25","DEMO1","DEMO18","DEMO11","DEMO15","DEMO21","DEMO14","DEMO6","DEMO8"];
const CO2_VALS  = [3.8,3.4,3.1,2.9,2.6,2.3,2.1,1.9,1.7,1.5,1.3];

const EPC_SITES = [
  "DEMO13·Muzeo Naz...","DEMO7·Bonnington res.","DEMO8·Mall",
  "DEMO15·Vasto res.","DEMO11·Altenberg res.","DEMO16·Siège social",
  "DEMO2·Werd res.","DEMO1·Coworking space","DEMO10·Dublin office","DEMO3·Admin communale",
];
const EPC_RIGHT_SITES = [
  "DEMO20·Shopping mall","DEMO77·Residence du Château","DEMO6·Humboldt-Universität",
  "DEMO5·Costenhof res.","DEMO19·Palacio de Madrid","DEMO18·Student residence",
  "DEMO9·Commonwealth Office","DEMO4·Coworking space","DEMO21·New town hall","DEMO13·Rotterdam office",
];
const EPC_TARGET = [80,65,55,45,38,30,25,18,12,5];
const EPC_ACTUAL = [100,60,70,35,42,28,32,15,8,3];

const SCATTER_POINTS = [
  {x:2000,y:180},{x:5000,y:120},{x:8000,y:200},{x:12000,y:150},
  {x:15000,y:100},{x:3000,y:80},{x:20000,y:250},{x:25000,y:90},
  {x:1000,y:60},{x:7000,y:130},{x:18000,y:170},{x:10000,y:110},
];

const DASHBOARDS = [
  { id:0, label:"Bảng điều khiển",                       icon:"⭐", subtitle:"Default dashboard of the account" },
  { id:1, label:"1. Energy audit",                 icon:null },
  { id:2, label:"2. CO2 emissions",                icon:null },
  { id:3, label:"3. Energy Performance Contracts", icon:null },
];

// ─── Widget ───────────────────────────────────────────────────────────────────
function Widget({ title, date, children, cols=1, minH=220, accent="#2563eb" }) {
  return (
    <div style={{
      gridColumn:`span ${cols}`,background:"white",borderRadius:10,
      boxShadow:"0 1px 4px rgba(0,0,0,0.08)",border:"1px solid #f1f5f9",
      padding:16,display:"flex",flexDirection:"column",gap:10,
      minHeight:minH,transition:"box-shadow .2s",
    }}
      onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,0.12)"}
      onMouseLeave={e=>e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.08)"}
    >
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{width:10,height:10,borderRadius:"50%",background:accent}}/>
          <span style={{fontWeight:600,fontSize:13,color:"#0f172a"}}>{title}</span>
        </div>
        <div style={{display:"flex",gap:6}}>
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:13}}>⤢</button>
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:13}}>⋯</button>
        </div>
      </div>
      {date && <div style={{fontSize:11,color:"#64748b",display:"flex",alignItems:"center",gap:5}}><span>📅</span>{date}</div>}
      <div style={{flex:1}}>{children}</div>
    </div>
  );
}

// ─── Gauge ───────────────────────────────────────────────────────────────────
function GaugeChart({ value=5.1, max=750, unit="kWh/m²", size=180 }) {
  const pct=Math.min(value/max,1), angle=-180+pct*180;
  const r=70,cx=90,cy=90;
  const segs=[
    {c:"#22c55e",f:-180,t:-108},{c:"#86efac",f:-108,t:-36},
    {c:"#fbbf24",f:-36,t:36},{c:"#f97316",f:36,t:108},{c:"#ef4444",f:108,t:120},
  ];
  const pt=(deg,ri)=>{const rad=deg*Math.PI/180;return{x:cx+ri*Math.cos(rad),y:cy+ri*Math.sin(rad)};};
  const arc=(f,t)=>{
    const ri=r,ro=r+14,p1=pt(f,ri),p2=pt(t,ri),p3=pt(t,ro),p4=pt(f,ro);
    return `M${p1.x},${p1.y}A${ri},${ri} 0 0 1 ${p2.x},${p2.y}L${p3.x},${p3.y}A${ro},${ro} 0 0 0 ${p4.x},${p4.y}Z`;
  };
  const np=pt(angle,r-4);
  return (
    <svg viewBox="0 0 180 105" style={{width:size,maxWidth:"100%"}}>
      {segs.map((s,i)=><path key={i} d={arc(s.f,s.t)} fill={s.c}/>)}
      <line x1={cx} y1={cy} x2={np.x} y2={np.y} stroke="#1e293b" strokeWidth={3} strokeLinecap="round"/>
      <circle cx={cx} cy={cy} r={5} fill="#1e293b"/>
      <text x={cx} y={cy+20} textAnchor="middle" fontSize={15} fontWeight="800" fill="#0f172a">{value}</text>
      <text x={cx} y={cy+32} textAnchor="middle" fontSize={7} fill="#64748b">{unit}</text>
    </svg>
  );
}

// ─── Donut ───────────────────────────────────────────────────────────────────
function DonutChart({ value=98.4, color="#22c55e", size=120 }) {
  const r=38,cx=55,cy=55,sw=13,c=2*Math.PI*r,dash=(value/100)*c;
  return (
    <svg viewBox="0 0 110 110" style={{width:size}}>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e2e8f0" strokeWidth={sw}/>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke={color} strokeWidth={sw}
        strokeDasharray={`${dash} ${c-dash}`} strokeDashoffset={c/4} strokeLinecap="round"/>
      <text x={cx} y={cy+5} textAnchor="middle" fontSize={14} fontWeight="800" fill="#0f172a">{value}%</text>
    </svg>
  );
}

// ─── Energy Label ─────────────────────────────────────────────────────────────
function EnergyLabel({ current="A", value=2.6, unit="kWh/m²" }) {
  const labels=["A","B","C","D","E","F"],colors=["#22c55e","#86efac","#fbbf24","#f97316","#ef4444","#dc2626"];
  return (
    <div style={{display:"flex",flexDirection:"column",gap:3}}>
      {labels.map((l,i)=>(
        <div key={l} style={{display:"flex",alignItems:"center",gap:6}}>
          <div style={{
            background:colors[i],color:"white",fontWeight:700,
            width:28+i*6,height:20,display:"flex",alignItems:"center",
            justifyContent:"center",fontSize:10,borderRadius:2,
            clipPath:"polygon(0 0,calc(100% - 7px) 0,100% 50%,calc(100% - 7px) 100%,0 100%)"
          }}>{l}</div>
          {l===current&&<span style={{fontSize:11,fontWeight:700,color:"#0f172a",background:"#f0fdf4",padding:"1px 6px",borderRadius:3}}>{value} {unit}</span>}
        </div>
      ))}
    </div>
  );
}

// ─── Vertical Bars ───────────────────────────────────────────────────────────
function BarChart({ sites, values, color, maxVal=10, barW=22 }) {
  const h=80;
  return (
    <div style={{display:"flex",alignItems:"flex-end",gap:2}}>
      {sites.map((s,i)=>{
        const bh=Math.max(2,(values[i]/maxVal)*h);
        return (
          <div key={i} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:2,flexShrink:0}}>
            <div style={{width:barW,height:bh,background:color,borderRadius:"3px 3px 0 0",cursor:"pointer",transition:"opacity .15s"}}
              onMouseEnter={e=>e.target.style.opacity=.7} onMouseLeave={e=>e.target.style.opacity=1} title={`${s}: ${values[i]}`}/>
            <span style={{fontSize:6.5,color:"#64748b",writingMode:"vertical-rl",transform:"rotate(180deg)",height:32}}>{s}</span>
          </div>
        );
      })}
    </div>
  );
}

// ─── Horizontal Bars (EPC) ────────────────────────────────────────────────────
function HBarChart({ leftSites, rightSites, actuals, targets }) {
  const maxV=Math.max(...actuals,...targets)*1.15;
  const half=Math.ceil(actuals.length/2);
  return (
    <div style={{display:"flex",gap:8,alignItems:"stretch"}}>
      {/* Left labels */}
      <div style={{display:"flex",flexDirection:"column",gap:5,minWidth:160,justifyContent:"space-around"}}>
        {leftSites.map(s=><div key={s} style={{fontSize:9.5,color:"#374151",height:16,display:"flex",alignItems:"center"}}>{s}</div>)}
      </div>
      {/* Bars */}
      <div style={{flex:1,display:"flex",flexDirection:"column",gap:5}}>
        {actuals.map((a,i)=>{
          const tPct=(targets[i]/maxV)*100,aPct=(a/maxV)*100,over=a>targets[i];
          return (
            <div key={i} style={{display:"flex",alignItems:"center",height:16,gap:1}}>
              <div style={{width:`${tPct}%`,height:10,background:over?"#ef4444":"#22c55e",borderRadius:2}}/>
              {over
                ? <div style={{width:`${aPct-tPct}%`,height:10,background:"#fca5a5",borderRadius:2}}/>
                : <div style={{width:`${tPct-aPct}%`,height:10,background:"#bbf7d0",borderRadius:2}}/>
              }
            </div>
          );
        })}
      </div>
      {/* Right labels */}
      <div style={{display:"flex",flexDirection:"column",gap:5,minWidth:160,justifyContent:"space-around"}}>
        {rightSites.map(s=><div key={s} style={{fontSize:9.5,color:"#374151",height:16,display:"flex",alignItems:"center"}}>{s}</div>)}
      </div>
    </div>
  );
}

// ─── Pareto ───────────────────────────────────────────────────────────────────
function ParetoChart({ sites, values, barColor="#7c3aed" }) {
  const maxV=Math.max(...values),h=85;
  let cum=0;const total=values.reduce((a,b)=>a+b,0);
  const cums=values.map(v=>{cum+=v;return(cum/total)*100;});
  const n=values.length;
  return (
    <div style={{position:"relative",height:h+38}}>
      <div style={{display:"flex",alignItems:"flex-end",gap:2,height:h,position:"absolute",bottom:36,left:0,right:0}}>
        {values.map((v,i)=>(
          <div key={i} style={{flex:1,height:(v/maxV)*h,background:barColor,borderRadius:"2px 2px 0 0",opacity:.85}}/>
        ))}
      </div>
      <svg style={{position:"absolute",bottom:36,left:0,width:"100%",height:h}} viewBox={`0 0 ${n} 100`} preserveAspectRatio="none">
        <polyline points={cums.map((c,i)=>`${i+0.5},${100-c}`).join(" ")} fill="none" stroke="#ef4444" strokeWidth={0.6}/>
        {cums.map((c,i)=><circle key={i} cx={i+0.5} cy={100-c} r={0.6} fill="#ef4444"/>)}
      </svg>
      <div style={{display:"flex",gap:2,position:"absolute",bottom:0,left:0,right:0,height:34}}>
        {sites.map((s,i)=><div key={i} style={{flex:1,fontSize:6,color:"#64748b",writingMode:"vertical-rl",transform:"rotate(180deg)",overflow:"hidden",textAlign:"center"}}>{s}</div>)}
      </div>
    </div>
  );
}

// ─── Scatter ─────────────────────────────────────────────────────────────────
function ScatterPlot({ points }) {
  const maxX=Math.max(...points.map(p=>p.x)),maxY=Math.max(...points.map(p=>p.y));
  const W=200,H=120,pad=22;
  const sx=p=>(p.x/maxX)*(W-pad)+pad;
  const sy=p=>H-(p.y/maxY)*(H-pad)-pad*0.5;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{width:"100%",height:"100%"}}>
      <line x1={pad} y1={H-pad} x2={W} y2={H-pad} stroke="#e2e8f0" strokeWidth={0.5}/>
      <line x1={pad} y1={2} x2={pad} y2={H-pad} stroke="#e2e8f0" strokeWidth={0.5}/>
      {[50,100,150,200].map(v=>(
        <line key={v} x1={pad} y1={H-pad-(v/maxY)*(H-pad)} x2={W} y2={H-pad-(v/maxY)*(H-pad)} stroke="#f1f5f9" strokeWidth={0.4}/>
      ))}
      <line x1={sx({x:0})} y1={sy({y:0})} x2={sx({x:maxX})} y2={sy({y:maxY*0.7})} stroke="#60a5fa" strokeWidth={1} strokeDasharray="2,2"/>
      {points.map((p,i)=><circle key={i} cx={sx(p)} cy={sy(p)} r={3} fill="#3b82f6" opacity={0.75}/>)}
      <text x={W/2} y={H} textAnchor="middle" fontSize={6} fill="#94a3b8">Surface (m²)</text>
      <text x={6} y={H/2} textAnchor="middle" fontSize={6} fill="#94a3b8" transform={`rotate(-90,6,${H/2})`}>Consumption (MWh)</text>
    </svg>
  );
}

// ─── World Map ────────────────────────────────────────────────────────────────
function WorldMap({ alarmCount=17 }) {
  const alarm=alarmCount>5;
  const pins=[
    {x:"52%",y:"28%",label:`${alarmCount}`,alarm,color:"#ef4444"},
    {x:"72%",y:"35%",label:"2",alarm:false,color:"#22c55e"},
    {x:"20%",y:"65%",label:"",alarm:false,color:"#6b7280"},
    {x:"32%",y:"68%",label:"2",alarm:false,color:"#22c55e"},
  ];
  return (
    <div style={{position:"relative",background:"#dbeafe",borderRadius:8,overflow:"hidden",height:180}}>
      <svg viewBox="0 0 400 220" style={{width:"100%",height:"100%",opacity:.65}}>
        <rect width={400} height={220} fill="#bfdbfe"/>
        <ellipse cx={150} cy={100} rx={62} ry={46} fill="#86efac" opacity={.85}/>
        <ellipse cx={225} cy={80} rx={82} ry={55} fill="#86efac" opacity={.85}/>
        <ellipse cx={315} cy={110} rx={50} ry={35} fill="#86efac" opacity={.85}/>
        <ellipse cx={78} cy={140} rx={35} ry={28} fill="#86efac" opacity={.85}/>
        <ellipse cx={342} cy={162} rx={28} ry={20} fill="#86efac" opacity={.85}/>
      </svg>
      {pins.map((p,i)=>(
        <div key={i} style={{
          position:"absolute",left:p.x,top:p.y,transform:"translate(-50%,-50%)",
          background:p.alarm?"rgba(239,68,68,0.2)":p.color,
          border:p.alarm?"2px solid #ef4444":"none",
          borderRadius:"50%",width:p.label?28:18,height:p.label?28:18,
          display:"flex",alignItems:"center",justifyContent:"center",
          fontSize:11,fontWeight:700,color:"white",boxShadow:"0 2px 8px rgba(0,0,0,0.2)",cursor:"pointer"
        }}>{p.label}</div>
      ))}
      <div style={{position:"absolute",bottom:4,left:8,fontSize:9,color:"#64748b"}}>© Google</div>
    </div>
  );
}

// ─── Action List ─────────────────────────────────────────────────────────────
function ActionList({ items }) {
  return (
    <div style={{display:"flex",flexDirection:"column"}}>
      {items.map((a,i)=>(
        <div key={i} style={{padding:"7px 0",borderBottom:"1px solid #f8fafc",display:"flex",alignItems:"center",gap:8}}>
          <span style={{color:a.status==="Đang làm"?"#ef4444":"#64748b",fontSize:13,flexShrink:0}}>↑</span>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",justifyContent:"space-between",gap:4}}>
              <span style={{fontSize:12,fontWeight:600,color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.title}</span>
              <span style={{fontSize:10,color:"#ef4444",flexShrink:0,fontWeight:500}}>{a.date}</span>
            </div>
            <div style={{display:"flex",gap:5,marginTop:3}}>
              <span style={{
                fontSize:9,padding:"2px 5px",borderRadius:3,fontWeight:600,flexShrink:0,
                background:a.status==="Đang làm"?"#fef3c7":"#dbeafe",
                color:a.status==="Đang làm"?"#92400e":"#1d4ed8"
              }}>{a.status}</span>
              <span style={{fontSize:9,color:"#94a3b8",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.site}</span>
            </div>
          </div>
          <div style={{width:20,height:20,borderRadius:"50%",background:"#1e293b",flexShrink:0}}/>
        </div>
      ))}
    </div>
  );
}

// ─── Perimeter Sidebar ───────────────────────────────────────────────────────
const PERIMETER_TREE = [
  { country:"France",    count:3, sites:[{id:"DEMO1",name:"Coworking Space"},{id:"DEMO16",name:"Siège Social"},{id:"DEMO20",name:"Shopping Mall"}] },
  { country:"Germany",   count:3, sites:[{id:"DEMO4",name:"New town hall"},{id:"DEMO5",name:"Gostenhof residence"},{id:"DEMO6",name:"Humboldt-Universität"}] },
  { country:"Ireland",   count:1, sites:[{id:"DEMO10",name:"Dublin office"}] },
  { country:"Italy",     count:3, sites:[{id:"DEMO8",name:"Mall"},{id:"DEMO13",name:"Muzeo Nazionale"},{id:"DEMO15",name:"Vasto Residence"}] },
  { country:"Netherlands",count:2,sites:[{id:"DEMO3",name:"Admin Communale"},{id:"DEMO21",name:"New Town Hall"}] },
  { country:"Senegal",   count:1, sites:[{id:"DEMO24",name:"Immeuble Dakar"}] },
  { country:"Spain",     count:2, sites:[{id:"DEMO19",name:"Palacio de Madrid"},{id:"DEMO22",name:"BCN Office"}] },
  { country:"Switzerland",count:2,sites:[{id:"DEMO2",name:"Werd Residence"},{id:"DEMO23",name:"Basel Center"}] },
  { country:"United Kingdom",count:3,sites:[{id:"DEMO7",name:"Bonnington Res."},{id:"DEMO9",name:"Commonwealth Office"},{id:"DEMO11",name:"Altenberg Res."}] },
]
const ALL_SITE_IDS = PERIMETER_TREE.flatMap(c=>c.sites.map(s=>s.id))
const TOTAL = ALL_SITE_IDS.length

function Sidebar({ open, onClose }) {
  const [search,       setSearch]      = useState("")
  const [expanded,     setExpanded]    = useState({"Germany":true})
  const [checked,      setChecked]     = useState(new Set(ALL_SITE_IDS))
  const [filterCount]                  = useState(0)
  const [hoveredSite,  setHoveredSite] = useState(null)

  const totalChecked = checked.size

  // Country-level helpers
  const countryChecked = (sites) => sites.filter(s=>checked.has(s.id)).length
  const countryState   = (sites) => {
    const n = countryChecked(sites)
    if (n===0) return "none"
    if (n===sites.length) return "all"
    return "partial"
  }

  const toggleSelectAll = () => {
    setChecked(checked.size===TOTAL ? new Set() : new Set(ALL_SITE_IDS))
  }

  const toggleCountry = (sites) => {
    const st = countryState(sites)
    const next = new Set(checked)
    if (st==="all") sites.forEach(s=>next.delete(s.id))
    else             sites.forEach(s=>next.add(s.id))
    setChecked(next)
  }

  const toggleSite = (id) => {
    const next = new Set(checked)
    next.has(id) ? next.delete(id) : next.add(id)
    setChecked(next)
  }

  const toggleExpand = (country) =>
    setExpanded(p=>({...p,[country]:!p[country]}))

  // Filter visible countries
  const filtered = PERIMETER_TREE.filter(c=>{
    if (!search) return true
    return c.country.toLowerCase().includes(search.toLowerCase()) ||
           c.sites.some(s=>s.name.toLowerCase().includes(search.toLowerCase()) ||
                           s.id.toLowerCase().includes(search.toLowerCase()))
  })

  const CheckBox = ({ state="none", size=12 }) => (
    <div style={{
      width:size, height:size, borderRadius:2, flexShrink:0,
      background: state==="none" ? "white" : "#2563eb",
      border: state==="none" ? "2px solid #94a3b8" : "2px solid #2563eb",
      display:"flex", alignItems:"center", justifyContent:"center",
      cursor:"pointer", transition:"all .15s"
    }}>
      {state==="all"     && <span style={{color:"white",fontSize:size*0.7,lineHeight:1,fontWeight:900}}>✓</span>}
      {state==="partial" && <div style={{width:size*0.5,height:2,background:"white",borderRadius:1}}/>}
    </div>
  )

  return (
    <div style={{
      width:open?272:0, minWidth:open?272:0, overflow:"hidden", flexShrink:0,
      background:"#f8fafc", borderRight:"1px solid #e2e8f0",
      transition:"width .25s ease, min-width .25s ease",
      display:"flex", flexDirection:"column"
    }}>
      {/* Header */}
      <div style={{
        padding:"14px 16px 10px",
        display:"flex", justifyContent:"space-between", alignItems:"center",
        borderBottom:"1px solid #e2e8f0", background:"#f8fafc", flexShrink:0
      }}>
        <span style={{fontWeight:700, fontSize:14, color:"#0f172a"}}>Phạm vi</span>
        <button onClick={onClose} style={{
          background:"none", border:"1px solid #cbd5e1", borderRadius:4,
          padding:"2px 10px", cursor:"pointer", fontSize:14, color:"#64748b",
          lineHeight:1.4
        }}>−</button>
      </div>

      {/* Filters row */}
      <div style={{
        padding:"10px 16px", display:"flex",
        justifyContent:"space-between", alignItems:"center", flexShrink:0
      }}>
        <span style={{fontSize:12, color:"#64748b", fontWeight:500}}>
          Filters ({filterCount})
        </span>
        <button style={{
          width:28, height:28, borderRadius:"50%", background:"#22c55e",
          border:"none", cursor:"pointer", color:"white", fontSize:18,
          display:"flex", alignItems:"center", justifyContent:"center",
          boxShadow:"0 2px 6px rgba(34,197,94,.35)", lineHeight:1
        }}>+</button>
      </div>

      {/* Search */}
      <div style={{padding:"0 16px 10px", flexShrink:0}}>
        <div style={{
          display:"flex", background:"white", border:"1px solid #e2e8f0",
          borderRadius:6, padding:"6px 10px", gap:6, alignItems:"center"
        }}>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="Tìm kiếm..."
            style={{border:"none", outline:"none", flex:1, fontSize:12, background:"transparent", color:"#374151"}}
          />
          <span style={{color:"#94a3b8", fontSize:14}}>🔍</span>
        </div>
      </div>

      {/* Select all */}
      <div style={{padding:"0 16px 8px", flexShrink:0}}>
        <div onClick={toggleSelectAll} style={{
          display:"flex", alignItems:"center", gap:9, cursor:"pointer",
          padding:"5px 0"
        }}>
          <CheckBox state={totalChecked===TOTAL?"all":totalChecked===0?"none":"partial"}/>
          <span style={{fontSize:12, fontWeight:600, color:"#374151"}}>
            Select all ({TOTAL})
          </span>
        </div>
      </div>

      {/* Country list */}
      <div style={{flex:1, overflowY:"auto", padding:"0 8px 16px"}}>
        {filtered.map(({country, count, sites}) => {
          const state   = countryState(sites)
          const isOpen  = !!expanded[country]
          // If searching, show only matching sites
          const visSites = search
            ? sites.filter(s=>
                s.name.toLowerCase().includes(search.toLowerCase()) ||
                s.id.toLowerCase().includes(search.toLowerCase()) ||
                country.toLowerCase().includes(search.toLowerCase()))
            : sites

          return (
            <div key={country} style={{marginBottom:4}}>
              {/* Country row */}
              <div style={{
                display:"flex", alignItems:"center", gap:8,
                padding:"7px 8px", borderRadius:6, cursor:"pointer",
                background: state!=="none" ? "#fff" : "#f8fafc",
                border:"1px solid", borderColor: isOpen?"#dbeafe":"#e2e8f0",
                transition:"all .15s"
              }}>
                <div onClick={()=>toggleCountry(sites)}>
                  <CheckBox state={state}/>
                </div>
                <span onClick={()=>toggleExpand(country)} style={{
                  fontSize:12, fontWeight:600, color:"#374151", flex:1
                }}>
                  {country} ({count})
                </span>
                <button onClick={()=>toggleExpand(country)} style={{
                  background:"none", border:"1px solid #cbd5e1", borderRadius:3,
                  width:20, height:20, cursor:"pointer", color:"#64748b",
                  display:"flex", alignItems:"center", justifyContent:"center",
                  fontSize:11, flexShrink:0
                }}>
                  {isOpen ? "−" : "+"}
                </button>
              </div>

              {/* Sites list */}
              {isOpen && (
                <div style={{
                  margin:"2px 0 2px 12px",
                  borderLeft:"2px solid #dbeafe",
                  paddingLeft:8
                }}>
                  {visSites.map(site=>{
                    const isSel   = checked.has(site.id)
                    const isHover = hoveredSite===site.id
                    return (
                      <div key={site.id}
                        onClick={()=>toggleSite(site.id)}
                        onMouseEnter={()=>setHoveredSite(site.id)}
                        onMouseLeave={()=>setHoveredSite(null)}
                        style={{
                          display:"flex", alignItems:"center", gap:9,
                          padding:"7px 8px", borderRadius:6, cursor:"pointer",
                          background: isHover||isSel ? "#dbeafe" : "transparent",
                          marginBottom:2, transition:"background .1s"
                        }}
                      >
                        <CheckBox state={isSel?"all":"none"} size={11}/>
                        <div style={{flex:1, minWidth:0}}>
                          <div style={{
                            fontSize:12, fontWeight:600,
                            color: isSel ? "#1d4ed8" : "#374151",
                            overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"
                          }}>{site.name}</div>
                          <div style={{
                            fontSize:10, color:"#94a3b8",
                            fontFamily:"monospace", marginTop:1
                          }}>{site.id}</div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          )
        })}
      </div>

      {/* Footer: selection count */}
      <div style={{
        padding:"10px 16px",
        borderTop:"1px solid #e2e8f0",
        background:"white",
        display:"flex", alignItems:"center", justifyContent:"space-between",
        flexShrink:0
      }}>
        <span style={{fontSize:11, color:"#64748b"}}>
          <b style={{color:"#2563eb"}}>{totalChecked}</b> / {TOTAL} sites selected
        </span>
        <button style={{
          fontSize:11, background:"#2563eb", color:"white",
          border:"none", borderRadius:5, padding:"4px 12px", cursor:"pointer",
          fontWeight:600
        }}>Áp dụng</button>
      </div>
    </div>
  )
}

// ═══ DASHBOARD VIEWS ═════════════════════════════════════════════════════════

function MainDashboard() {
  return (
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
      <Widget title="Bản đồ" date="06/06/2023 - 06/06/2024" minH={260}>
        <WorldMap alarmCount={17}/>
      </Widget>
      <Widget title="Hiệu suất năng lượng" date="06/06/2023 - 06/06/2024">
        <div style={{display:"flex",justifyContent:"center",paddingTop:8}}>
          <GaugeChart value={5.1} max={750}/>
        </div>
      </Widget>
      <Widget title="Tiết kiệm đạt được" date="06/06/2023 - 06/06/2024">
        <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100%"}}>
          <DonutChart value={98.4}/>
        </div>
      </Widget>
      <Widget title="Hành động sắp tới" minH={260}>
        <ActionList items={ACTIONS_FULL}/>
      </Widget>
      <Widget title="Tổng diện tích giám sát" date="06/06/2023 - 06/06/2024">
        <div style={{display:"flex",alignItems:"baseline",gap:8,justifyContent:"center",paddingTop:20}}>
          <span style={{fontSize:42,fontWeight:800,color:"#0f172a",letterSpacing:-1}}>74 770</span>
          <span style={{fontSize:20,color:"#64748b"}}>m²</span>
        </div>
      </Widget>
      <Widget title="TOP/FLOP hiệu suất/m²" date="06/06/2023 - 06/06/2024" cols={2}>
        <div style={{display:"flex",gap:4,alignItems:"flex-end",overflow:"auto"}}>
          <BarChart sites={TOP_SITES} values={TOP_VALUES} color="#ef4444"/>
          <div style={{width:1,background:"#e2e8f0",alignSelf:"stretch",margin:"0 4px"}}/>
          <BarChart sites={FLOP_SITES} values={FLOP_VALUES} color="#22c55e"/>
        </div>
      </Widget>
      <Widget title="Ghi chú">
        <div style={{background:"#fef9c3",borderRadius:6,padding:12,fontSize:11,color:"#374151",lineHeight:1.75}}>
          <p style={{fontWeight:600,marginBottom:6}}>Các mục tiêu tiết kiệm năng lượng toàn cầu được xác định trong quy định năng lượng là</p>
          <p>– achieve 40% savings by 2030</p><p>– achieve 50% savings by 2040</p><p>– achieve 60% savings by 2050</p>
        </div>
      </Widget>
    </div>
  );
}

function EnergyAuditDashboard() {
  return (
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
      <Widget title="Hiệu suất năng lượng" date="06/06/2023 - 06/06/2024">
        <div style={{display:"flex",gap:14,alignItems:"center",justifyContent:"center",flexWrap:"wrap"}}>
          <EnergyLabel current="A" value={2.6}/>
          <div>
            <div style={{fontSize:11,color:"#64748b",fontWeight:600,marginBottom:6}}>Đường cơ sở</div>
            <div style={{display:"flex",alignItems:"center",gap:6}}>
              <div style={{background:"#f97316",clipPath:"polygon(0 0,calc(100% - 7px) 0,100% 50%,calc(100% - 7px) 100%,0 100%)",padding:"3px 10px",color:"white",fontWeight:700,fontSize:11,borderRadius:2}}>F ▶</div>
              <span style={{fontWeight:700,fontSize:14}}>335 k…</span>
            </div>
          </div>
        </div>
      </Widget>
      <Widget title="TOP/FLOP tiêu thụ/m² (hiệu chỉnh)" date="06/06/2023 - 06/06/2024" cols={2}>
        <div style={{display:"flex",gap:4,alignItems:"flex-end",overflow:"auto"}}>
          <BarChart sites={TOP_SITES.slice(0,8)} values={TOP_VALUES.slice(0,8)} color="#ef4444"/>
          <div style={{width:1,background:"#e2e8f0",alignSelf:"stretch",margin:"0 4px"}}/>
          <BarChart sites={FLOP_SITES.slice(0,8)} values={FLOP_VALUES.slice(0,8)} color="#22c55e"/>
        </div>
      </Widget>
      <Widget title="Kế hoạch hành động">
        <ActionList items={ACTIONS_FULL.slice(0,3)}/>
      </Widget>
      <Widget title="Cảnh báo hiện tại">
        <WorldMap alarmCount={20}/>
      </Widget>
      <Widget title="Địa điểm chiếm 80%..." date="06/06/2023 - 06/06/2024">
        <ParetoChart sites={TOP_SITES} values={TOP_VALUES} barColor="#60a5fa"/>
      </Widget>
      <Widget title="Cơ cấu năng lượng" date="06/06/2023 - 06/06/2024">
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:11,color:"#64748b"}}>Tổng</div>
          <div style={{fontSize:18,fontWeight:800,color:"#f59e0b",marginBottom:8}}>849,13 MWh</div>
          <DonutChart value={99.75} size={100}/>
          <div style={{fontSize:10,marginTop:8,textAlign:"left",padding:"0 8px"}}>
            <div style={{display:"flex",gap:6,marginBottom:2}}><span style={{color:"#22c55e"}}>●</span>Electricity 846.99 MWh</div>
            <div style={{display:"flex",gap:6}}><span style={{color:"#fbbf24"}}>●</span>Natural gas 2.15 MWh</div>
          </div>
        </div>
      </Widget>
      <Widget title="Phân bổ chi phí năng lượng..." date="06/06/2023 - 06/06/2024">
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:11,color:"#64748b"}}>Tổng</div>
          <div style={{fontSize:20,fontWeight:800,color:"#0f172a",marginBottom:6}}>1 €</div>
          <svg viewBox="0 0 120 120" style={{width:110,display:"block",margin:"0 auto"}}>
            {[{c:"#f59e0b",pct:.4,s:0},{c:"#ef4444",pct:.3,s:.4},{c:"#94a3b8",pct:.3,s:.7}].map((seg,i)=>{
              const a1=(seg.s*2-.5)*Math.PI,a2=((seg.s+seg.pct)*2-.5)*Math.PI,cx=60,cy=60,r=44;
              return <path key={i} d={`M${cx},${cy}L${cx+r*Math.cos(a1)},${cy+r*Math.sin(a1)}A${r},${r} 0 ${seg.pct>.5?1:0} 1 ${cx+r*Math.cos(a2)},${cy+r*Math.sin(a2)}Z`} fill={seg.c} opacity={.9}/>;
            })}
            <circle cx={60} cy={60} r={24} fill="white"/>
          </svg>
          <div style={{fontSize:10,marginTop:6,textAlign:"left",padding:"0 8px",display:"flex",flexDirection:"column",gap:2}}>
            <div><span style={{color:"#f59e0b"}}>●</span> Consumption 0.4€ <b>40%</b></div>
            <div><span style={{color:"#ef4444"}}>●</span> Distribution 0.3€ <b>30%</b></div>
            <div><span style={{color:"#94a3b8"}}>●</span> Taxes 0.3€ <b>30%</b></div>
          </div>
        </div>
      </Widget>
    </div>
  );
}

function CO2Dashboard() {
  const months=["Jul","Aug","Sep","Oct","Nov","Dec","Jan","Feb","Mar","Apr","May","Jun"];
  const monthly=[12,8,14,11,9,16,13,7,10,8,6,4];
  const maxM=Math.max(...monthly);
  return (
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
      {/* Environmental performance */}
      <Widget title="Hiệu suất môi trường" date="06/06/2023 - 06/06/2024">
        <div style={{display:"flex",gap:12,alignItems:"center",justifyContent:"center",flexWrap:"wrap"}}>
          <EnergyLabel current="A" value={1.7} unit="kgCO₂/m²"/>
          <div>
            <div style={{fontSize:11,color:"#64748b",fontWeight:600,marginBottom:6}}>Đường cơ sở</div>
            <div style={{display:"flex",alignItems:"center",gap:6}}>
              <div style={{background:"#ef4444",clipPath:"polygon(0 0,calc(100% - 7px) 0,100% 50%,calc(100% - 7px) 100%,0 100%)",padding:"3px 10px",color:"white",fontWeight:700,fontSize:11,borderRadius:2}}>E ▶</div>
              <span style={{fontWeight:700,fontSize:14}}>96 kgC…</span>
            </div>
          </div>
        </div>
      </Widget>

      {/* CO2 savings vs last year — big number */}
      <Widget title="CO2 savings vs last year (%)" date="06/06/2023 - 06/06/2024">
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100%"}}>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:52,fontWeight:900,color:"#ef4444",letterSpacing:-2,lineHeight:1}}>−35.5</div>
            <div style={{fontSize:22,fontWeight:700,color:"#ef4444"}}>%</div>
            <div style={{fontSize:11,color:"#64748b",marginTop:6}}>vs previous year</div>
          </div>
        </div>
      </Widget>

      {/* Carbon action plan */}
      <Widget title="Kế hoạch carbon" accent="#22c55e">
        <ActionList items={ACTIONS_FULL}/>
      </Widget>

      {/* Yearly CO2 budget */}
      <Widget title="Yearly CO2 budget" date="06/06/2023 - 06/06/2024">
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          <div style={{display:"flex",justifyContent:"flex-end",gap:10,fontSize:10,color:"#64748b"}}>
            <span><span style={{color:"#7c3aed"}}>■</span> Actual</span>
            <span><span style={{color:"#22c55e"}}>—</span> Budget</span>
          </div>
          <div style={{position:"relative",height:100}}>
            <div style={{display:"flex",alignItems:"flex-end",gap:2,height:80}}>
              {monthly.map((v,i)=>(
                <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:1}}>
                  <div style={{width:"100%",height:(v/maxM)*70,background:"#7c3aed",borderRadius:"2px 2px 0 0",opacity:.8}}/>
                  <span style={{fontSize:6.5,color:"#64748b"}}>{months[i]}</span>
                </div>
              ))}
            </div>
            <svg style={{position:"absolute",top:0,left:0,width:"100%",height:80}} viewBox="0 0 100 100" preserveAspectRatio="none">
              <line x1={0} y1={48} x2={100} y2={48} stroke="#22c55e" strokeWidth={1.5} strokeDasharray="3,2"/>
            </svg>
          </div>
          <div style={{display:"flex",justifyContent:"space-between"}}>
            <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:18}}>‹</button>
            <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:18}}>›</button>
          </div>
        </div>
      </Widget>

      {/* Sites 80% CO2 */}
      <Widget title="Sites accounting for 80% of my total CO2 emissions" date="06/06/2023 - 06/06/2024" cols={2}>
        <ParetoChart sites={CO2_SITES} values={CO2_VALS} barColor="#7c3aed"/>
      </Widget>

      {/* Note */}
      <Widget title="Ghi chú" cols={2}>
        <div style={{background:"#fef9c3",borderRadius:6,padding:12,fontSize:11,color:"#374151",lineHeight:1.75}}>
          <p style={{fontWeight:600}}>In order to meet the Energy Transition targets, the global CO2 emissions should decrease by 5% each year.</p>
        </div>
      </Widget>
    </div>
  );
}

function EPCDashboard() {
  return (
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
      {/* Map */}
      <Widget title="Bản đồ" minH={240}>
        <WorldMap alarmCount={20}/>
      </Widget>

      {/* Actual vs target MWh */}
      <Widget title="Actual vs target performance (MWh)" date="06/06/2023 - 06/06/2024">
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100%"}}>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:56,fontWeight:900,color:"#ef4444",letterSpacing:-2}}>0</div>
            <div style={{fontSize:18,fontWeight:600,color:"#64748b"}}>MWh</div>
          </div>
        </div>
      </Widget>

      {/* Actual vs target % — Gauge */}
      <Widget title="Actual vs target performance (%)" date="06/06/2023 - 06/06/2024">
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%"}}>
          <GaugeChart value={0.7} max={100} unit="%"/>
          <div style={{fontSize:26,fontWeight:800,color:"#ef4444",marginTop:-8}}>0.7 <span style={{fontSize:16}}>%</span></div>
        </div>
      </Widget>

      {/* Energy mix */}
      <Widget title="Energy mix" date="06/06/2023 - 06/06/2024">
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:11,color:"#64748b"}}>Tổng</div>
          <div style={{fontSize:18,fontWeight:800,color:"#f59e0b",marginBottom:8}}>330,43 MWh</div>
          <DonutChart value={99.35} size={100}/>
          <div style={{fontSize:10,marginTop:8,textAlign:"left",padding:"0 8px"}}>
            <div style={{display:"flex",gap:6,marginBottom:2}}><span style={{color:"#22c55e"}}>●</span>Electricity 328.29 MWh</div>
            <div style={{display:"flex",gap:6}}><span style={{color:"#fbbf24"}}>●</span>Natural gas 2.15 MWh</div>
          </div>
        </div>
      </Widget>

      {/* Energy signature */}
      <Widget title="Energy signature" date="06/06/2023 - 06/06/2024" minH={200}>
        <div style={{height:155}}>
          <ScatterPlot points={SCATTER_POINTS}/>
        </div>
      </Widget>

      {/* TOP/FLOP actual vs target horizontal */}
      <Widget title="TOP/FLOP actual vs target performance (%)" date="06/06/2023 - 06/06/2024" cols={3}>
        <div style={{fontSize:10,color:"#64748b",marginBottom:8,display:"flex",gap:12}}>
          <span><span style={{color:"#22c55e"}}>■</span> Below target</span>
          <span><span style={{color:"#ef4444"}}>■</span> Above target</span>
        </div>
        <HBarChart leftSites={EPC_SITES} rightSites={EPC_RIGHT_SITES} actuals={EPC_ACTUAL} targets={EPC_TARGET}/>
      </Widget>
    </div>
  );
}

// ═══ DASHBOARD PAGE — s'intègre dans AppLayout (pas de header/rail propres) ══
export default function EMSDashboard() {
  const [perimeterOpen, setPerimeterOpen] = useState(false);
  const [activeDash,    setActiveDash]    = useState(0);
  const [dashDropdown,  setDashDropdown]  = useState(false);
  const [linked,        setLinked]        = useState(false);
  const [animKey,       setAnimKey]       = useState(0);

  const switchDash = (id) => { setActiveDash(id); setDashDropdown(false); setAnimKey(k=>k+1); };

  return (
    <div style={{display:"flex",height:"100%",background:"#f1f5f9",overflow:"hidden",fontFamily:"'DM Sans','Segoe UI',sans-serif"}}>
      <style>{`@keyframes fadeSlide{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}`}</style>

      {/* ── Perimeter Sidebar (panneau gauche optionnel) ── */}
      <Sidebar open={perimeterOpen} onClose={()=>setPerimeterOpen(false)}/>

      {/* ── Zone principale ── */}
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>

        {/* Toolbar */}
        <div style={{display:"flex",alignItems:"center",gap:10,background:"white",borderBottom:"1px solid #e2e8f0",padding:"8px 14px",flexShrink:0,boxShadow:"0 1px 2px rgba(0,0,0,0.04)"}}>

          {/* Bouton ouvrir Perimeter */}
          <button onClick={()=>setPerimeterOpen(true)} title="Phạm vi" style={{
            background:"#eff6ff",border:"none",borderRadius:6,width:28,height:28,
            cursor:"pointer",fontSize:16,color:"#2563eb",
            display:"flex",alignItems:"center",justifyContent:"center"
          }}>+</button>

          {/* Sélecteur de dashboard */}
          <div style={{position:"relative"}}>
            <button onClick={()=>setDashDropdown(!dashDropdown)} style={{
              display:"flex",alignItems:"center",gap:8,background:"none",border:"none",
              cursor:"pointer",fontWeight:700,fontSize:14,color:"#0f172a",
              padding:"4px 10px",borderRadius:6,transition:"background .15s"
            }}
              onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
              onMouseLeave={e=>e.currentTarget.style.background="none"}
            >
              {DASHBOARDS[activeDash].label}
              <span style={{color:"#94a3b8",fontSize:12}}>▾</span>
            </button>

            {dashDropdown && (
              <div style={{
                position:"absolute",top:"110%",left:0,background:"white",
                border:"1px solid #e2e8f0",borderRadius:10,padding:6,
                zIndex:300,minWidth:295,boxShadow:"0 8px 28px rgba(0,0,0,0.14)"
              }}>
                {DASHBOARDS.map(d=>(
                  <div key={d.id} onClick={()=>switchDash(d.id)} style={{
                    padding:"9px 12px",borderRadius:6,cursor:"pointer",
                    background:d.id===activeDash?"#eff6ff":"transparent",transition:"background .15s"
                  }}
                    onMouseEnter={e=>{if(d.id!==activeDash)e.currentTarget.style.background="#f8fafc"}}
                    onMouseLeave={e=>{if(d.id!==activeDash)e.currentTarget.style.background="transparent"}}
                  >
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      {d.icon&&<span>{d.icon}</span>}
                      <span style={{fontSize:13,fontWeight:d.id===activeDash?600:400,color:d.id===activeDash?"#2563eb":"#374151"}}>{d.label}</span>
                    </div>
                    {d.subtitle&&<div style={{fontSize:10,color:"#94a3b8",marginTop:2,paddingLeft:d.icon?20:0}}>{d.subtitle}</div>}
                  </div>
                ))}
                <div style={{borderTop:"1px solid #f1f5f9",margin:"4px 0 0",padding:"6px 12px"}}>
                  <button style={{background:"none",border:"none",cursor:"pointer",fontSize:11,color:"#64748b",display:"flex",alignItems:"center",gap:6}}>
                    ⚙ Manage dashboards
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Droite — link periods + actions */}
          <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:12,color:"#64748b"}}>Liên kết khoảng thời gian</span>
            <button onClick={()=>setLinked(!linked)} style={{
              width:38,height:20,borderRadius:10,
              background:linked?"#2563eb":"#cbd5e1",
              border:"none",cursor:"pointer",position:"relative",transition:"background .2s"
            }}>
              <div style={{width:14,height:14,borderRadius:"50%",background:"white",position:"absolute",top:3,left:linked?21:3,transition:"left .2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}}/>
            </button>
            <span style={{fontSize:11,color:"#f59e0b"}}>⭐</span>
            <span style={{fontSize:11,color:"#64748b"}}>Bảng mặc định của…</span>
            <button style={{background:"#fef3c7",border:"none",borderRadius:6,padding:"3px 10px",cursor:"pointer",fontSize:13}}>✏</button>
            <button style={{background:"none",border:"none",cursor:"pointer",fontSize:15,color:"#94a3b8"}}>⋯</button>
          </div>
        </div>

        {/* Grilles de widgets */}
        <div key={animKey} style={{flex:1,overflowY:"auto",padding:14,animation:"fadeSlide .3s ease"}}>
          {activeDash===0&&<MainDashboard/>}
          {activeDash===1&&<EnergyAuditDashboard/>}
          {activeDash===2&&<CO2Dashboard/>}
          {activeDash===3&&<EPCDashboard/>}
        </div>
      </div>
    </div>
  );
}
